export default "__VITE_PUBLIC_ASSET__f8947b03__"